import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    return FinanceApi.get('/customer/refunds', config);
}
const get = async (code) => {
    return FinanceApi.get('/customer/refunds/' + code);
}
const store = async (data) => {
    return FinanceApi.post('/customer/refunds', data);
}
const update = async (id, formData) => {
    return FinanceApi.put('/customer/refunds/' + id, formData);
}
const del = async (id) => {
    return FinanceApi.delete('/customer/refunds/' + id);
}
const importExcel = async (config) => {
    return FinanceApi.post('customer/refunds/excel-import', config);
}
const exportExcel = async (config) => {
    return FinanceApi.get('/customer/refunds/excel-export',{...config,responseType:'arraybuffer'});
}
export default {
    getAll,
    get,
    store,
    update,
    del,
    importExcel,
    exportExcel
}
